import React, { useState } from "react";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import moment from "moment";
import {
  ApprovalStatus,
  MessageType,
  TaskStatus,
  priorityValueColor,
  priorityValueLable,
} from "../../utils/constant";
import ProfileDetailModal from "../ProfileDetailModal";
import StartTask from "../../page/chat/MessageComponent/StartTask";
import { useDispatch } from "react-redux";
import { handleArchiveTask } from "../../appStore/actions/ArkchatGroup/action";
import { useTranslation } from "react-i18next";
import { handleThreadScrollToBottom } from "../../appStore/actions/AppState/action";
import {
  fontSizeSchemes,
  personIconStyle,
  taskButtonStyle,
  taskButtonTxtStyle,
} from "../../assets/commonFunction";
import TaskStatusButton from "../../components/TaskStatusButton/TaskStatusButton";
import DividerView from "../DividerView/DividerView";
import PersonIcon from "../../assets/images/chats/person.svg";
import useAppSelectors from "../../customHooks/useAppSelectors";
import HandleLink from "../../page/chat/MessageComponent/HandleLink";
const classes = {
  chatUserprofile: {
    bgcolor: "#E3E1E1",

    width: "30px",
    minWidth: "30px",
    height: "30px",
    display: "flex",

    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",

    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },

  userlink: {
    color: "#2C86FF",
    lineHeight: "15px",
    fontSize: "13px",
    fontWeight: "450",
  },
  duetime: {
    color: "#000",
    opacity: "80%",
    fontSize: "13px",
    paddingTop: "1px",
  },
  userlink2: {
    color: "#2C86FF",
    display: "inline-block",
    fontSize: "14px",
  },
  userInfo: {
    marginTop: "-5px !important",
    width: "100%",
  },
  tick: {
    objectFit: "cover",
    maxWidth: "17px",
    maxHeight: "6px",
    img: {
      width: "100%",
    },
  },
  pendingT: {
    borderRadius: "4px",
    padding: "5px 7px",
    textAlign: "center",
    maxHeight: "1.5rem",
    // maxWidth: "90px",
    justifyContent: "center",
    alignItems: "centre",
    whiteSpace: "nowrap",
  },

  chatpri: {
    borderRadius: "3px",
    textAlign: "center",
    lineHeight: "14px",
    fontSize: fontSizeSchemes.font12,
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
};
const ApprovalCard = ({
  taskItem,
  handleViewThreadClick,
  handleClickTaskUpdate,
  handleStartTask,
  groupList,

  setProfileViewModal,
  isProfileViewOpen,
  profileViewData,
  setProfileViewData,
  handleShowUserProfile,
  setStartTaskOpen,
  startTaskOpen,
  tabValue,
  levelLabel
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const appContent = t("AppContent", { returnObjects: true });
  const [expanded, setExpanded] = useState(false);

  const { currentUserData } = useAppSelectors();

  const statusDetailsBoxWidth = 85;

  return (
    <>
      <ProfileDetailModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
        setProfileViewData={setProfileViewData}
      />

      <Box width="100%" key={taskItem?.id + "TaskMessagecond"}>
        {/* -----------------subUser details------------------ */}
        <Stack
          direction="row"
          spacing={1}
          justifyContent={"space-between"}
          alignItems={"flex-end"}
        >
          <Stack
            mt={"0.5rem"}
            width={"100%"}
            direction="row"
            spacing={1}
            gap={"0 5px"}
          >
            <Box sx={classes.userInfo}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                width="100%"
              >
                <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
                  {taskItem?.assignee?.pp ? (
                    <Box
                      onClick={() =>
                        handleShowUserProfile(taskItem?.assignee?.id)
                      }
                      sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                    >
                      <img
                        src={taskItem?.assignee?.pp}
                        alt="profile"
                        height="100%"
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{ cursor: "pointer" }}
                      bgcolor={"#E3E1E1"}
                      width={"30px"}
                      height={"30px"}
                      display={"flex"}
                      flex={"none"}
                      alignItems={"center"}
                      flex-wrap={"wrap"}
                      justifyContent={"center"}
                      borderRadius={"0.15rem"}
                      onClick={() =>
                        handleShowUserProfile(taskItem?.assignee?.id)
                      }
                    >
                      <img
                        src={PersonIcon}
                        alt="profile"
                        style={personIconStyle}
                      />
                    </Box>
                  )}

                  <Stack alignItems={"center"} direction="row" spacing={1}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={400}
                      fontSize={fontSizeSchemes.font14}
                    >
                      {taskItem?.type === MessageType?.Task
                        ? "Assignee"
                        : "Approver"}{" "}
                      : {taskItem?.assignee?.name}
                    </Typography>
                    <Typography
                      color={"#000"}
                      fontSize={fontSizeSchemes.font12}
                      fontWeight={400}
                    >
                      {/* Time */}
                      {moment(Math.floor(taskItem?.timetoken / 10000)).format(
                        currentUserData?.userDateTimeFormat,
                      )}
                    </Typography>
                  </Stack>
                </Box>

                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  gap={"0.5rem"}
                  mt={"0.5rem"}
                >
                 
                  {taskItem?.type === MessageType?.Task &&
                    taskItem?.assignee?.id === currentUserData?.id &&
                    (taskItem?.task_status === TaskStatus?.Pending ||
                      taskItem?.task_status === TaskStatus?.Delayed) && (
                      <Stack
                        direction="row"
                        position={"relative"}
                        sx={{
                          ...taskButtonStyle,
                          border: "1px solid #DB0011",
                          bgcolor: "transparent",
                          color: "#DB0011",
                          "&:hover": {
                            bgcolor: "#DB0011",
                            color: "#fff",
                          },
                        }}
                        onClick={() => handleStartTask(taskItem)}
                      >
                        {startTaskOpen?.timetoken === taskItem?.timetoken && (
                          <StartTask
                            open={
                              startTaskOpen?.timetoken === taskItem?.timetoken
                            }
                            taskData={taskItem}
                            setStartTaskOpen={setStartTaskOpen}
                          />
                        )}

                        <Typography
                          sx={{ ...taskButtonTxtStyle, color: "inherit" }}
                        >
                          {" "}
                          {appContent?.KEY348}{" "}
                        </Typography>
                      </Stack>
                    )}

                    <Typography
                          sx={{ ...taskButtonTxtStyle, color: "inherit" }}
                        >
                          {" "}
                          {levelLabel}{" "}Level Approval
                        </Typography>

                  {/* for approval */}
                  {taskItem?.type === MessageType?.Approval &&
                    (taskItem?.from?.id === currentUserData?.id ||
                      taskItem?.assignee?.id === currentUserData?.id) &&
                    taskItem?.approval_status !== ApprovalStatus?.Approved &&
                    taskItem?.approval_status !== ApprovalStatus?.Rejected &&
                    taskItem?.approval_status !== ApprovalStatus?.Cancelled && (
                      <Stack
                        direction="row"
                        alignItems={"center"}
                        sx={{
                          ...taskButtonStyle,
                          border: "1px solid #ccc",
                          bgcolor: "transparent",
                          color: "#333",
                          "&:hover": {
                            bgcolor: "#f5f5f5",
                          },
                        }}
                        onClick={() => handleClickTaskUpdate(taskItem)}
                      >
                        <Typography
                          sx={{ ...taskButtonTxtStyle, color: "inherit" }}
                        >
                          {" "}
                          {appContent?.KEY355}{" "}
                        </Typography>
                      </Stack>
                    )}

                  <Stack
                    direction="row"
                    alignItems={"center"}
                    sx={{
                      ...taskButtonStyle,
                      border: "1px solid #ccc",
                      bgcolor: "transparent",
                      color: "#333",
                      "&:hover": {
                        bgcolor: "#f5f5f5",
                      },
                    }}
                    onClick={() =>
                      dispatch(handleArchiveTask(taskItem?.id, taskItem?.type))
                    }
                  >
                    <Typography
                      sx={{ ...taskButtonTxtStyle, color: "inherit" }}
                    >
                      {" "}
                      {appContent?.KEY198}{" "}
                    </Typography>
                  </Stack>
                </Box>
              </Box>

              <Box
                width={"100%"}
                ml={"2.4rem"}
                sx={{
                  "@media (max-width: 1194px)": {
                    width: "100%",
                  },
                }}
              >
                <Box width={"100%"}>
                  <HandleLink>
                    {taskItem?.translations &&
                    taskItem?.translations[
                      taskItem?.to?.find(
                        (data) => data?.id === currentUserData?.id,
                      )?.languageCode
                    ] ? (
                      <Typography
                        sx={{ wordWrap: "break-word" }}
                        width={"100%"}
                        variant="body2"
                      >
                        {!expanded &&
                          taskItem?.to?.findIndex(
                            (idData) => idData?.id === currentUserData?.id,
                          ) !== -1 &&
                          taskItem?.translations[
                            taskItem?.to?.find(
                              (data) => data?.id === currentUserData?.id,
                            )?.languageCode
                          ]
                            ?.slice(0, 200)
                            ?.split(/\n/)
                            ?.map((line, indx) => (
                              <span
                                key={line + indx + "xyz007"}
                                style={{
                                  marginBottom: "0.5rem",
                                  display: "block",
                                  border:
                                    line === ""
                                      ? "1px solid transparent"
                                      : "none",
                                }}
                              >
                                <>{line === "" ? " " : line}</>
                              </span>
                            ))}{" "}
                        {!expanded &&
                        taskItem?.translations[
                          taskItem?.to?.find(
                            (data) => data?.id === currentUserData?.id,
                          )?.languageCode
                        ]?.length > 200
                          ? " ..."
                          : ""}
                        <Collapse
                          sx={{ wordWrap: "break-word" }}
                          in={expanded}
                          timeout="auto"
                          unmountOnExit
                        >
                          {taskItem?.to?.findIndex(
                            (idData) => idData?.id === currentUserData?.id,
                          ) !== -1 &&
                            taskItem?.translations[
                              taskItem?.to?.find(
                                (data) => data?.id === currentUserData?.id,
                              )?.languageCode
                            ]
                              ?.split(/\n/)
                              ?.map((line, indx) => (
                                <span
                                  key={line + indx + "xyz008"}
                                  style={{
                                    marginBottom: "0.5rem",
                                    display: "block",
                                    border:
                                      line === ""
                                        ? "1px solid transparent"
                                        : "none",
                                  }}
                                >
                                  <>{line === "" ? " " : line}</>
                                </span>
                              ))}
                        </Collapse>
                        {taskItem?.translations[
                          taskItem?.to?.find(
                            (data) => data?.id === currentUserData?.id,
                          )?.languageCode
                        ]?.length > 200 && (
                          <Typography
                            width={"100%"}
                            variant="body2"
                            expand={expanded}
                            onClick={() => setExpanded(!expanded)}
                            aria-expanded={expanded}
                            aria-label="show more"
                            sx={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            display={"inline"}
                            color={"#2C86FF"}
                          >
                            {expanded ? "less" : "more"}
                          </Typography>
                        )}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ wordWrap: "break-word" }}
                        width={"100%"}
                        variant="body2"
                      >
                        {!expanded &&
                          taskItem?.to?.findIndex(
                            (idData) => idData?.id === currentUserData?.id,
                          ) !== 1 &&
                          taskItem?.message?.slice(0, 200) +
                            (taskItem?.message?.length > 200 ? " ..." : "")}
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                          {taskItem?.to?.findIndex(
                            (idData) => idData?.id === currentUserData?.id,
                          ) !== 1 &&
                            taskItem?.message?.split(/\n/).map((line, indx) => (
                              <span
                                key={line + indx + "xyz009"}
                                style={{
                                  marginBottom: "0.5rem",
                                  display: "block",
                                  border:
                                    line === ""
                                      ? "1px solid transparent"
                                      : "none",
                                }}
                              >
                                {line}
                              </span>
                            ))}
                        </Collapse>

                        {taskItem?.message?.length > 200 && (
                          <Typography
                            width={"100%"}
                            variant="body2"
                            expand={expanded}
                            onClick={() => setExpanded(!expanded)}
                            aria-expanded={expanded}
                            aria-label="show more"
                            sx={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            display={"inline"}
                            color={"#2C86FF"}
                          >
                            {expanded ? "less" : "more"}
                          </Typography>
                        )}
                      </Typography>
                    )}
                  </HandleLink>
                </Box>
                <Box></Box>

                <Box
                  mt={"0.8rem"}
                  display={"flex"}
                  alignItems={"center"}
                  gap={"0.5rem"}
                >
                  {taskItem?.from?.pp ? (
                    <Box
                      onClick={() => handleShowUserProfile(taskItem?.from?.id)}
                      sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                    >
                      <img
                        src={taskItem?.from?.pp}
                        alt="profile"
                        height="100%"
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{ cursor: "pointer" }}
                      bgcolor={"#E3E1E1"}
                      width={"27px"}
                      height={"27px"}
                      display={"flex"}
                      flex={"none"}
                      alignItems={"center"}
                      flex-wrap={"wrap"}
                      justifyContent={"center"}
                      borderRadius={"0.15rem"}
                      onClick={() => handleShowUserProfile(taskItem?.from?.id)}
                    >
                      <img
                        src={PersonIcon}
                        alt="profile"
                        style={personIconStyle}
                      />
                    </Box>
                  )}
                  <Box display={"flex"} alignItems={"center"} gap={"0.2rem"}>
                    <Typography
                      fontSize={fontSizeSchemes.font14}
                      color={"#474747"}
                      fontWeight={400}
                    >
                      {taskItem?.type === MessageType?.Task
                        ? "Assigner"
                        : "Approval Seeker"}{" "}
                      :{" "}
                    </Typography>
                    <Typography fontSize={"0.87rem"} fontWeight={400}>
                      {taskItem?.from?.name}
                    </Typography>

                    <Box marginLeft={"1.6rem"}>
                      <TaskStatusButton
                        item={taskItem}
                        status={"approval"}
                        isCondition={taskItem?.type === MessageType?.Approval}
                      />

                      <TaskStatusButton
                        item={taskItem}
                        status={"task"}
                        isCondition={taskItem?.type === MessageType?.Task}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box width={"100%"} ml={"2.2rem"} mt={"0.5rem"}>
                  <Box
                    width={`${statusDetailsBoxWidth}%`}
                    display={"flex"}
                    alignItems={"center"}
                    gap={"0.2rem"}
                    flexWrap={"wrap"}
                  >
                    <Typography
                      // mt={"0.8rem"}
                      fontSize={fontSizeSchemes.font12}
                      fontWeight={400}
                      variant="subtitle2"
                    >
                      {appContent?.KEY195} :{" "}
                      {
                        groupList?.find((grp) => grp?.pnId === taskItem?.pnId)
                          ?.name
                      }
                    </Typography>
                    <DividerView />
                    <Typography
                      fontSize={fontSizeSchemes.font12}
                      fontWeight={400}
                    >
                      {appContent?.KEY342} :{" "}
                      {moment(Math.floor(taskItem?.timetoken / 10000)).format(
                        currentUserData?.userDateFormat,
                      )}
                    </Typography>
                    <DividerView />
                    <Typography
                      variant="subtitle2"
                      fontSize={fontSizeSchemes.font12}
                      fontWeight={600}
                    >
                      {" "}
                      {appContent?.KEY354} :{" "}
                      {moment(taskItem?.due_date).format(
                        currentUserData?.userDateFormat,
                      )}{" "}
                      {moment(taskItem?.due_time, "HH:mm").format(
                        currentUserData?.userTimeFormat,
                      )}
                    </Typography>
                    <DividerView />
                    <Typography
                      sx={classes.chatpri}
                      border={"1px solid transparent"}
                    >
                      {appContent?.KEY190} :
                      <span
                        style={{
                          display: "inline-block",
                          width: "13px",
                          height: "13px",
                          verticalAlign: "middle",
                          margin: "-1px 5px 0px 5px",
                          backgroundColor:
                            priorityValueColor[taskItem?.priority],
                        }}
                      ></span>
                      {priorityValueLable[taskItem?.priority]}
                    </Typography>
                    {taskItem?.start_time > 0 && (
                      <>
                        <DividerView />
                        <Typography
                          fontSize={fontSizeSchemes.font12}
                          fontWeight={400}
                        >
                          Started :{" "}
                          {moment
                            .unix(taskItem?.start_time)
                            .format(currentUserData?.userDateFormat)}
                        </Typography>
                      </>
                    )}
                    {taskItem?.estimated_time?.timeValue && (
                      <>
                        <DividerView />
                        <Box display={"flex"} gap={"0.8rem"}>
                          <Typography
                            fontSize={fontSizeSchemes.font12}
                            fontWeight={400}
                          >
                            {appContent?.KEY353} :{" "}
                            {taskItem?.estimated_time?.timeValue}{" "}
                            {taskItem?.estimated_time?.timeType}
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box
                    width={`${statusDetailsBoxWidth}%`}
                    display={"flex"}
                    alignItems={"center"}
                    gap={"0.2rem"}
                    flexWrap={"wrap"}
                  >
                    {taskItem?.estimated_time?.timeValue && (
                      <Box display={"flex"} gap={"0.8rem"}>
                        {taskItem?.actual_time?.timeValue && (
                          <Typography fontSize={"0.75rem"}>
                            Actual Time : {taskItem?.actual_time?.timeValue}{" "}
                            {taskItem?.actual_time?.timeType}
                          </Typography>
                        )}
                      </Box>
                    )}
                    <Box display={"flex"} gap={"0.2rem"}>
                      {taskItem?.end_time > 0 && (
                        <>
                          <DividerView />
                          <Typography
                            fontSize={fontSizeSchemes.font12}
                            fontWeight={600}
                          >
                            Finished :{" "}
                            {moment
                              .unix(taskItem?.end_time)
                              .format(currentUserData?.userDateFormat)}
                          </Typography>
                        </>
                      )}
                    </Box>
                    {taskItem?.estimated_time?.timeValue && (
                      <Box display={"flex"} gap={"0.2rem"}>
                        {taskItem?.end_time ? (
                          <>
                            <DividerView />
                            <Typography
                              color={
                                taskItem?.actual_time?.timeValue <
                                  taskItem?.estimated_time?.timeValue ||
                                Math.abs(taskItem?.diff_time?.timeValue) === 0
                                  ? "#007F8F"
                                  : "#DB0011"
                              }
                              fontSize={fontSizeSchemes.font12}
                              fontWeight={400}
                            >
                              {Math.abs(taskItem?.diff_time?.timeValue) > 0 ? (
                                <>
                                  {Math.abs(taskItem?.diff_time?.timeValue)}{" "}
                                  {taskItem?.diff_time?.timeType}{" "}
                                  {taskItem?.actual_time?.timeValue <
                                  taskItem?.estimated_time?.timeValue
                                    ? appContent?.KEY351
                                    : appContent?.KEY352}
                                </>
                              ) : (
                                <>{appContent?.KEY270}</>
                              )}
                            </Typography>
                          </>
                        ) : (
                          <></>
                        )}
                      </Box>
                    )}
                    <Typography
                      fontSize={fontSizeSchemes.font14}
                      fontWeight={400}
                      variant="subtitle2"
                      color={"#2C86FF"}
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(
                          handleThreadScrollToBottom(taskItem?.thread_id),
                        );
                        handleViewThreadClick(taskItem, tabValue);
                      }}
                    >
                      {appContent?.KEY349}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Stack>
        {/* -----------------subUser details------------------ */}
      </Box>
    </>
  );
};

export default ApprovalCard;
